module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-icon-email.png", __webpack_public_path__ + "_/_/_/_/common/faq/images/faq-icon-email.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-icon-email.png
// module id = 151
// module chunks = 5